<template>
  <BAlert :show="show"
          :variant="variant"
          :class="alertClass"
          class="d-flex">
    <Icon v-if="!hideIcon"
          :title="iconTitle"
          :name="iconName"
          class="mr-2"></Icon>
    <p v-if="messageIsHtml"
       class="m-0"
       v-html="message"></p>
    <p v-else
       class="m-0">
      <slot>{{ message }}</slot>
    </p>
  </BAlert>
</template>

<script>
  import { BAlert } from 'bootstrap-vue';
  import Icon from './Icon.vue';
  import translator from '~/zf/frontend/common/mixins/translator';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';

  /**
   * @deprecated Use the new MessageBoxPlain/MessageBoxWithIcon/MessageBoxWithImage instead
   */
  export default {
    name: 'AlertMessage',
    compatConfig: {
      MODE: 3,
    },
    components: {
      BAlert,
      Icon,
    },
    mixins: [translator],
    props: {
      alertClass: {
        type: String,
      },
      hideIcon: {
        type: Boolean,
        default: false,
      },
      message: {
        type: String,
      },
      messageIsHtml: {
        type: Boolean,
        default: false,
      },
      show: {
        type: Boolean,
        default: true,
      },
      variant: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        BootstrapVariant,
      };
    },
    computed: {
      iconName() {
        if (this.variant === BootstrapVariant.INFO) {
          return 'info2';
        }
        if (this.variant === BootstrapVariant.WARNING) {
          return 'warning2';
        }
        return 'cancel-circle2';
      },
      iconTitle() {
        if (this.variant === BootstrapVariant.INFO) {
          return this.tr('common.INFORMATION');
        }
        if (this.variant === BootstrapVariant.WARNING) {
          return this.tr('common.WARNING');
        }
        return this.tr('common.ERROR');
      },
    },
  };
</script>
